import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Country } from 'containers/common'
import { Input } from 'components/fields'
import { Module } from 'components/misc'

export default class AddressBlock extends PureComponent {
  static propTypes = {
    prependFields: PropTypes.node,
    withAction: PropTypes.bool,
    resetAward: PropTypes.bool,
    copyFrom: PropTypes.string,
    change: PropTypes.func,
    title: PropTypes.string,
    data: PropTypes.object,
    formPrefix: PropTypes.string,
    intlKey: PropTypes.string,
    style: PropTypes.object,
    readOnly: PropTypes.bool,
    showAddressLine1: PropTypes.bool,
    showAddressLine2: PropTypes.bool,
    showCity: PropTypes.bool,
    showRegion: PropTypes.bool,
    showZipCode: PropTypes.bool,
    showCountry: PropTypes.bool,
    isOrganizationAddress: PropTypes.bool
  }
  static defaultProps = {
    formPrefix: 'address',
    intlKey: 'moduleTitle.address',
    prependFields: null,
    isOrganizationAddress: false
  }

  handleActionClick = () => {
    const { change, copyFrom, formPrefix, data } = this.props

    if (copyFrom) {
      change(`${formPrefix}.line1`, get(data, `${copyFrom}.line1`))
      change(`${formPrefix}.line2`, get(data, `${copyFrom}.line2`))
      change(
        `${formPrefix}.stateOrProvinceOrRegion`,
        get(data, `${copyFrom}.stateOrProvinceOrRegion`)
      )
      change(`${formPrefix}.city`, get(data, `${copyFrom}.city`))
      change(`${formPrefix}.zipCode`, get(data, `${copyFrom}.zipCode`))
      change(`${formPrefix}.country.id`, get(data, `${copyFrom}.country.id`))
    }
  }

  render() {
    const {
      title = 'Address',
      change,
      withAction,
      formPrefix,
      resetAward,
      intlKey,
      prependFields,
      style,
      readOnly,
      showAddressLine1,
      showAddressLine2,
      showCity,
      showRegion,
      showZipCode,
      showCountry,
      isOrganizationAddress
    } = this.props

    const buttonDefinition = [
      {
        'order': 1,
        'secondary': true,
        'onClick': !readOnly && this.handleActionClick,
        'iconAction': null,
        'isActionLoading': false,
        'intlKeyAction': 'button.same_as_billing',
        'action': withAction && 'Same as billing'
      }
    ]

    return (
      <Module
        title={title}
        intlKey={intlKey}
        narrow
        style={style}
        buttonDefinition={buttonDefinition}
      >
        <div className="row">
          <div className="col-xs-12">{prependFields}</div>
          {(showAddressLine1 || isOrganizationAddress) &&
            <div className="col-xs-12">
              <Input
                label="Address Line 1"
                intlKey="label.addressLine1"
                name={`${formPrefix}.line1`}
                readonly={readOnly}
              />
            </div>}

          {(showAddressLine2 || isOrganizationAddress) &&
            <div className="col-xs-12">
              <Input
                label="Address Line 2"
                intlKey="label.addressLine2"
                name={`${formPrefix}.line2`}
                readonly={readOnly}
              />
            </div>}
        </div>

        <div className="row">
          {(showRegion || isOrganizationAddress) &&
            <div className="col-xs-6">
              <Input
                label="State/Province/Region"
                intlKey="label.state_province"
                name={`${formPrefix}.stateOrProvinceOrRegion`}
                readonly={readOnly}
              />
            </div>}

          {(showCity || isOrganizationAddress) &&
            <div className="col-xs-6">
              <Input
                label="City"
                intlKey="label.city"
                name={`${formPrefix}.city`}
                readonly={readOnly}
              />
            </div>}
        </div>

        <div className="row">
          {(showZipCode || isOrganizationAddress) &&
            <div className="col-xs-6">
              <Input
                label="Post code"
                intlKey="label.post_code"
                name={`${formPrefix}.zipCode`}
                readonly={readOnly}
              />
            </div>}

          {(showCountry || isOrganizationAddress) &&
            <div className="col-xs-6">
              <Country
                change={change}
                formPrefix={formPrefix}
                resetAward={resetAward}
                disabled={readOnly}
              />
            </div>}
        </div>
      </Module>
    )
  }
}
